import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from '@quero-delivery/quero-components-web';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import PlaceFareForm from '@/features/fare/PlaceFareForm';
import { AccessPermission } from '@/_components/access-permission';
import { useGetPlaceFare } from '@/features/fare/api/get-place-fare';

function PlaceFaresFormContainer() {
  const { placeId } = useParams<{ placeId: string }>();
  const navigate = useNavigate();

  const {
    data: placeInfo,
    error,
    isLoading,
  } = useGetPlaceFare({ placeId: placeId || '' }, { enabled: !!placeId });

  if (isLoading) {
    return (
      <div className="loading-container">
        <Loader />
      </div>
    );
  }

  if (error) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errorsData = (error as any).response?.data?.errors;
    return (
      <div className="container">
        <div className="header-container">
          <div className="back-label" onClick={() => navigate(-1)}>
            <FontAwesomeIcon icon={faChevronLeft} size="lg" />
            <strong>Voltar</strong>
          </div>
        </div>

        <div>
          {errorsData
            ? errorsData.map((err: string) => (
                <p key={err} className="mgn-sm" role="alert">
                  <b>Erro:</b> {err}
                </p>
              ))
            : 'Erro ao carregar tarifas do estabelecimento.'}
        </div>
      </div>
    );
  }

  return (
    <AccessPermission permissionKey="place.createAndEditFlare">
      <PlaceFareForm placeInfo={placeInfo} />
    </AccessPermission>
  );
}

export default PlaceFaresFormContainer;
